import React from 'react';

function Feed() {
  return (
    <>
      <div className="feed-area">
        <div className="feed-content">
        <div className="post-card">
          <div className="post-header">
            <div className="post-avatar"></div>
            <div className="post-info">
              <h3>Ayman Ansar</h3>
              <p>Just now</p>
            </div>
          </div>
          <div className="post-content">
            Reddit is a network of communities where people can dive into their interests, hobbies, and passions. There's a community for whatever you're interested in on Reddit. It's a platform where users can share content, participate in discussions, and engage with others who share similar interests. Reddit is divided by areas of interest called "subreddits," which can be about anything from news to politics to a specific topic or theme, and users can subscribe to the subreddits that interest them the most. The site has a vast array of content, including news, images, videos, and live streams, and users can interact with each other through comments, messages, and chat features. The platform has a focus on community and user-generated content, with users able to create their own subreddits and moderate them as they see fit.
          </div>
          <div className="post-actions">
            <button className="post-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </button>
            <button className="post-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 2l4 4-4 4"/>
                <path d="M3 11v-1a4 4 0 0 1 4-4h14"/>
                <path d="M7 22l-4-4 4-4"/>
                <path d="M21 13v1a4 4 0 0 1-4 4H3"/>
              </svg>
            </button>
            <button className="post-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="post-card">
          <div className="post-header">
            <div className="post-avatar"></div>
            <div className="post-info">
              <h3>Tyne AI</h3>
              <p>2 minutes ago</p>
            </div>
          </div>
          <div className="post-content">
            Sure, I've gone ahead and created this image in the Images section. Though you'll have to go to the Images section to preview and further edit your images.
          </div>
          <div className="post-actions">
            <button className="post-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="18" cy="5" r="3"/>
                <circle cx="6" cy="12" r="3"/>
                <circle cx="18" cy="19" r="3"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
              </svg>
              View in Images
            </button>
            <button className="post-action">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <path d="M2 12h20"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
              View in Browser
            </button>
          </div>
        </div>
        </div>
      </div>

      <div className="input-area">
        <div className="input-wrapper">
        <div className="input-container">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
          <input type="text" placeholder="Create, search or ask anything..." />
          <button className="send-button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/>
            </svg>
          </button>
        </div>
        </div>
      </div>
    </>
  );
}

export default Feed;
